module.exports = __webpack_public_path__ + "static/media/controls_prev.0b05adf0.svg";